module.exports = __webpack_public_path__ + "assets/img/invitation2.a4bb715f.png";